// Design tokens for the paywall page, literal values from the Figma "CMS Paywall" frame
// (plan 2026-10-01-ws7a-04, section 3). Kept local: they are specific to this page.
export const COLORS = {
  bgFrom: '#0A0F2A',
  bgTo: '#0B1020',
  card: '#121826',
  cardBorder: '#1E2433',
  tile: '#0F1420',
  text: '#FFFFFF',
  muted: '#A7B0C2',
  cta: '#006CFF'
};

// Per accent: identity colour (icon/check), price colour, card border, icon tint, optional shadow.
export const ACCENTS = {
  grey: { color: '#A7B0C2', price: '#A7B0C2', border: '#1E2433', tint: 'rgba(167,176,194,0.13)' },
  red: { color: '#E60023', price: '#E60023', border: 'rgba(230,0,35,0.12)', tint: 'rgba(230,0,35,0.12)' },
  blue: { color: '#006CFF', price: '#FFFFFF', border: 'rgba(0,108,255,0.2)', tint: 'rgba(0,108,255,0.12)' },
  purple: { color: '#8B5CF6', price: '#8B5CF6', border: 'rgba(139,92,246,0.2)', tint: 'rgba(139,92,246,0.12)' },
  gold: {
    color: '#F5C542',
    price: '#F5C542',
    border: 'rgba(245,197,66,0.2)',
    tint: 'rgba(245,197,66,0.13)',
    shadow: '0 10px 28px -8px rgba(245,197,66,0.13)'
  }
};

export const FONT = "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Hiragino Sans', 'Noto Sans JP', sans-serif";

export const focusRing = `
  &:focus-visible {
    outline: 2px solid #FFFFFF;
    outline-offset: 2px;
  }
`;
